<section
  class="banner"
  [class]="'banner--' + banner().state"
  [attr.data-cy]="qaKeys.Banner"
  [attr.data-state]="banner().state"
  role="status"
  aria-live="polite">
  <span class="banner__accent" aria-hidden="true"></span>

  @if (isLoading()) {
    <fv-loader class="banner__loader" variant="line-spinner" size="xs" [overlay]="false" />
  }
  @if (isEmpty()) {
    <div class="banner__illustration" aria-hidden="true">
      <fv-empty-illustration />
    </div>
  }

  <div class="banner__body">
    <h2 class="banner__title">{{ banner().title }}</h2>
    <p class="banner__subtitle">{{ banner().subtitle }}</p>
  </div>
</section>
